// Internal module — consumers should import from './metrics' (barrel) instead.
const MONTH_FORMATTER = new Intl.DateTimeFormat(undefined, { month: 'short', timeZone: 'UTC' });

const formatMonth = (d: Date): string => MONTH_FORMATTER.format(d);

export const formatNumber = (n: number): string => n.toLocaleString('en-US');

// e.g. "17 Mar"
export const formatWeekLabel = (dateIso: string): string => {
  const d = new Date(dateIso);
  return `${d.getUTCDate()} ${formatMonth(d)}`;
};

// e.g. "17–23 Mar 2026" or "29 Mar – 4 Apr 2026"
export const formatWeekRange = (startIso: string, endIso: string): string => {
  const start = new Date(startIso);
  const end = new Date(endIso);
  const startDay = start.getUTCDate();
  const endDay = end.getUTCDate();
  const startMonth = formatMonth(start);
  const endMonth = formatMonth(end);
  const year = end.getUTCFullYear();

  if (start.getUTCMonth() === end.getUTCMonth() && start.getUTCFullYear() === end.getUTCFullYear()) {
    return `${startDay}–${endDay} ${endMonth} ${year}`;
  }
  return `${startDay} ${startMonth} – ${endDay} ${endMonth} ${year}`;
};

export const calcWoWChange = (current: number, previous: number): number | null => {
  if (previous === 0) return null;
  return ((current - previous) / previous) * 100;
};

export const formatWoWChange = (change: number | null): string => {
  if (change === null) return '—';
  const sign = change > 0 ? '+' : '';
  return `${sign}${change.toFixed(1)}%`;
};
